export interface InitTFAResponse {
  account: string;
  issuer: string;
  passcode: string;
  qr_code: string;
}

export interface ConfirmTFAParams {
  totp: string;
}

export type ConfirmTFAResponse = Record<string, unknown>;

export type DisableTFAResponse = Record<string, unknown>;

export interface TFAStatusResponse {
  '2FAs': TOTP[];
}

interface TOTP {
  type: 'TOTP';
  status: TFAStatus;
}

export enum TFAStatus {
  None = 'none',
  Pending = 'pending',
  Enabled = 'enabled',
}

